type AnyObject = Record<string, unknown>

export const replaceNulls = (obj: AnyObject): void => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (value && typeof value === 'object') {
      replaceNulls(value as AnyObject)
      // eslint-disable-next-line no-eq-null, eqeqeq
    } else if (value == null) {
      // Using == to catch both null and undefined
      // eslint-disable-next-line no-param-reassign
      obj[key] = ''
    }
  })
}

export const removeNulls = (obj: AnyObject): void => {
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    if (value && typeof value === 'object') {
      removeNulls(value as AnyObject)
      // eslint-disable-next-line no-eq-null, eqeqeq
    } else if (value == null) {
      // Using == to catch both null and undefined
      // eslint-disable-next-line no-param-reassign
      delete obj[key]
    }
  })
}
